import { Injectable } from "@angular/core";
import { PlanningSettingsService } from "../../settings/services/planning-settings.service";
import { RiskRAGMatrixService } from "../services/risk-rag-matrix.service";
import { RESOLVER_KEYS } from "./resolver-init-keys";

@Injectable({ providedIn: 'root' })
export class SharedInitService {
  private loaded = new Set<string>();

  constructor(
    private readonly planningSettingsService: PlanningSettingsService,
    private readonly riskRAGMatrixService: RiskRAGMatrixService
  ) {
  }

  initRagMatrix() {
    if (this.loaded.has(RESOLVER_KEYS.RAG_MATRIX)) {
      return;
    }

    this.riskRAGMatrixService.initRAGMatrix();
    this.loaded.add(RESOLVER_KEYS.RAG_MATRIX);
  }

  getAutoUpdates() {
    if (this.loaded.has(RESOLVER_KEYS.AUTO_UPDATES)) {
      return;
    }

    this.planningSettingsService.getAutoUpdates();
    this.loaded.add(RESOLVER_KEYS.AUTO_UPDATES);
  }
}
